import { useModel } from '@umijs/max';
import React, { useEffect } from 'react';
import { syncNavThemeHtmlClass } from '@/utils/navThemeHtmlClass';

/** 与 initialState.settings.navTheme 同步 document.documentElement 上的主题类 */
const NavThemeHtmlClass: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const nav = initialState?.settings?.navTheme;

  useEffect(() => {
    if (nav === 'light' || nav === 'realDark') {
      syncNavThemeHtmlClass(nav);
    }
  }, [nav]);

  return null;
};

export default NavThemeHtmlClass;

